import React, { useEffect, useState, useMemo } from "react";
import { isMobileOnly, isTablet } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import i18n from "../../../../lib/i18n/i18n";
import { connect } from "react-redux";
import { Container, Title, TitleText } from "./fundingBodiesSearch.styles";
import Table from "../../../SivanPlusTable/SivanPlusTable";
import { getFundingBodies, deleteFundingBodies } from "../../../../actions/adminActions";
import QuestionModal from "../../../Modal/QuestionModal";
import { toast } from "react-toastify";
const currLanguage = i18n.language;
const dictionary = i18n.getDataByLanguage(currLanguage).common;

const fbColumns = isMobileOnly
  ? [
      {
        Header: dictionary.table.name,
        accessor: "name",
        Cell: ({ row: { original } }) => (
          <b>{original.name}</b>
        ),
      },
      {
        Header: "pc",
        accessor: "pc",
        Cell: ({ row: { original } }) => (
          <span>{original.pc}</span>
        ),
      },
    ]
  : isTablet
  ? [
      {
        Header: dictionary.table.name,
        accessor: "name",
        Cell: ({ row: { original } }) => (
          <span>{original.name}</span>
        ),
      },
      {
        Header: "pc",
        accessor: "pc",
        Cell: ({ row: { original } }) => (
          <span>{original.pc}</span>
        ),
      },
      {
        Header: dictionary.table.email,
        accessor: "email",
      },
    ]
  : [
      {
        Header: dictionary.table.name,
        accessor: "name",
        Cell: ({ row: { original } }) => (
          <b>{original.name}</b>
        ),
      },
      {
        Header: "pc",
        accessor: "pc",
        Cell: ({ row: { original } }) => (
          <span>{original.pc}</span>
        ),
      },
      {
        Header: dictionary.table.email,
        accessor: "email",
      },
    ];

const ClientsSearch = ({
  history,
  schoolId,
  user
}) => {
  const { t, i18n } = useTranslation("common");
  const [clients, setClients] = useState([]);
  const [isTableLoading, setIsTableLoading] = useState(true);
  const [isred, setIsRed] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [isLoadingDeleteStudent, setIsLoadingDeleteStudent] = useState(false);
  const [deleteUserData, setDeleteUserData] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [tableColumns, setTableColumns] = useState(fbColumns);

  useEffect(() => {
    fetchData();
  }, [schoolId]);

  const fetchData = async () =>  {
    setIsTableLoading(true)
    let data = [];
    try {
      data = await getFundingBodies(schoolId);
    } catch (e) {
      toast.error("כישלון במחיקת תלמיד");
      console.error(e)
    }
    setClients(data);
    setIsTableLoading(false)
  }

  useEffect(() => {
    fetchData();
    if (tableColumns[0].accessor !== "city") {
      const _tableColumns = [
        {
          Header: '',
          accessor: "city",
          Cell: ({ row: { original } }) => {
            return (
              <><span
                style={{ flex: "0 20%", fontSize: "18px" }}
                className="icons8-delete"
                onClick={() => {
                  setDeleteUserData(original)
                  setIsDeleteModal(true);
                } } />
              </>
            )
          }
        },
        ...fbColumns
      ];
      setTableColumns(_tableColumns)
    }
  }, []);

  const localDelete = async () => {
    setIsLoadingDeleteStudent(true);
    setIsDeleteModal(false);
    try {
      const iseDeleted = await deleteFundingBodies(schoolId, deleteUserData.id)
      // if (iseDeleted == '1') {
        toast.success("התלמיד הוסר");
      //   fetchData()
      // } else if (iseDeleted == '-1') {
      //   toast.warning("Student have active lessons.");
      // } else if (iseDeleted == '-2') {
      //   toast.warning("Student have credit incoms.");
      // }
    } catch(e) {
      toast.error("כישלון במחיקת תלמיד");
      console.error(e)
    }
    setDeleteUserData(null);
    setIsLoadingDeleteStudent(false);
  }

  const closeQuestionModal = async () => {
    setDeleteUserData(null);
    setIsDeleteModal(false);    
    // fetchData();
  }
  return (
    <Container>
      <Title>
        <TitleText>Funding Bodies</TitleText>
      </Title>
      <QuestionModal
        titleText="Do you whant delete funding body ?"
        isDelete={true}
        isLoaded={isLoadingDeleteStudent}
        deleteItem={localDelete}
        modalIsOpen={isDeleteModal}
        closeModal={closeQuestionModal}
      />
      <Table
        data={clients}
        componentColumns={tableColumns}
        // onRowClick={onRowClick}
        isLoading={isTableLoading}
      />
    </Container>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    user: state.session.user,
    isLoggedIn: state.session.isLoggedIn,
  };
}

export default withRouter(
  connect(mapStateToProps, {})(ClientsSearch)
);
